export default function ({ store, redirect, route }) {
  store.app.router.beforeEach((to, from, next) => {
    if (from.name === 'dashboard' && to.name === 'quote-quoteid-annual') {
      // forced redirect - dashboard -> payment
      return redirect('/')
    }
    if (from.name === 'dashboard' && to.name === 'success-gocardlless') {
      // forced redirect - dashboard -> success page
      return redirect('/')
    }
    if (from.name === 'dashboard' && to.name === 'success-free') {
      // forced redirect - dashboard ->  success page
      return redirect('/')
    }
    next()
  })
  // store.app.router.afterEach(async (to, from, next) => {
  //   const _toQuote = to.name.includes('quote')
  //   const _fromNotQuote = !from.name.includes('quote')
  //   if (_toQuote && _fromNotQuote) {
  //     // fetch quote
  //     if (route.params.quoteid) {
  //       await store.dispatch('quote/fetchQuote', route.params.quoteid)
  //       await store.dispatch('quote/calculatePrice')
  //     }
  //   }
  // })
}
